import React, { useState, useEffect } from 'react';
import { Card, Input, Button, message, Icon, Tag, Spin, Alert } from 'antd';

import { previewEmail, enviarTeste } from '../api';
import { explicaFunil, formataDuracao, SOURCE_LABEL } from '../helpers';

/**
 * Passo 3 — ver como chega e conferir antes de disparar.
 *
 * A prévia usa um cliente real como amostra: ver "{{nome}}" na tela não diz
 * nada sobre como a mensagem vai chegar.
 */
const PassoRevisao = ({ campanha, funil, previsao, emailTeste, onChangeEmailTeste }) => {
  const [html, setHtml] = useState('');
  const [amostra, setAmostra] = useState(null);
  const [remetente, setRemetente] = useState('');
  const [carregando, setCarregando] = useState(true);
  const [enviandoTeste, setEnviandoTeste] = useState(false);

  useEffect(() => {
    if (!campanha.id) return;
    setCarregando(true);
    previewEmail(campanha.id)
      .then((dados) => {
        if (!dados) return;
        setHtml(dados.html || '');
        setAmostra(dados.amostra);
        setRemetente(dados.remetente || '');
      })
      .finally(() => setCarregando(false));
  }, [campanha.id, campanha.updated_marker]);

  const dispararTeste = () => {
    if (!emailTeste) {
      message.warning('Informe o e-mail que vai receber o teste.');
      return;
    }
    setEnviandoTeste(true);
    enviarTeste(campanha.id, emailTeste)
      .then(() => message.success('Teste enviado para ' + emailTeste))
      .catch(() => message.error('Não foi possível enviar o teste.'))
      .finally(() => setEnviandoTeste(false));
  };

  const linha = (rotulo, valor) => (
    <div style={{ display: 'flex', padding: '7px 0', borderBottom: '1px solid #f0f0f0' }}>
      <div style={{ width: 170, color: '#8c8c8c', fontSize: 13 }}>{rotulo}</div>
      <div style={{ flex: 1, fontSize: 13 }}>{valor}</div>
    </div>
  );

  return (
    <div>
      <Card size="small" title="Enviar um teste" style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <Input
            style={{ maxWidth: 320 }}
            placeholder="seu@email.com"
            value={emailTeste}
            onChange={(e) => onChangeEmailTeste(e.target.value)}
            onPressEnter={dispararTeste}
          />
          <Button type="primary" onClick={dispararTeste} loading={enviandoTeste} icon="mail">
            Enviar teste
          </Button>
        </div>
        <div style={{ fontSize: 12, color: '#8c8c8c', marginTop: 8 }}>
          {amostra
            ? <span>As variáveis vão preenchidas com os dados de <strong>{amostra}</strong>.</span>
            : 'As variáveis vão preenchidas com dados de exemplo.'}
        </div>
      </Card>

      <Card size="small" title="Conferir antes de disparar" style={{ marginBottom: 16 }}>
        {linha('Remetente', (
          <span>
            <strong>{campanha.from_name || 'Contlabs'}</strong>
            {remetente && <span style={{ color: '#8c8c8c' }}> &lt;{remetente}&gt;</span>}
            <div style={{ fontSize: 12, color: '#8c8c8c' }}>
              O endereço é o do domínio autenticado — é o que mantém a campanha
              fora do lixo eletrônico.
            </div>
          </span>
        ))}
        {linha('Assunto', campanha.subject || <span style={{ color: '#f5222d' }}>faltando</span>)}
        {linha('Origem dos e-mails', SOURCE_LABEL[campanha.source] || '—')}
        {linha('Destinatários', funil ? (
          <span>
            <strong style={{ fontSize: 15 }}>{funil.receberao}</strong>
            {explicaFunil(funil).length > 0 && (
              <span style={{ color: '#8c8c8c' }}> · não recebem: {explicaFunil(funil).join(', ')}</span>
            )}
          </span>
        ) : '—')}
        {linha('Tempo de envio', funil ? formataDuracao(previsao) + ' (60 por minuto)' : '—')}
        {linha('Descadastro', <Tag color="green" style={{ margin: 0 }}>Link incluído no rodapé</Tag>)}
      </Card>

      <Card size="small" title="Como o e-mail vai chegar">
        <Alert
          type="warning"
          showIcon
          style={{ marginBottom: 12 }}
          message="A prévia é aproximada"
          description="Cada cliente de e-mail renderiza de um jeito. O teste no seu próprio endereço é o que mostra a verdade — principalmente no Outlook."
        />
        {carregando ? (
          <div style={{ textAlign: 'center', padding: 40 }}><Spin /></div>
        ) : (
          <div style={{ border: '1px solid #e8e8e8', borderRadius: 6, overflow: 'hidden', background: '#f0f2f5' }}>
            <iframe
              title="Prévia do e-mail"
              srcDoc={html}
              sandbox=""
              style={{ width: '100%', height: 520, border: 0, display: 'block' }}
            />
          </div>
        )}
        <div style={{ fontSize: 12, color: '#8c8c8c', marginTop: 8 }}>
          <Icon type="lock" /> A prévia roda isolada: o HTML não executa script nem acessa o sistema.
        </div>
      </Card>
    </div>
  );
};

export default PassoRevisao;
